import { render } from "./FootballFenxi.vue?vue&type=template&id=279a3215&scoped=true&ts=true"
import script from "./FootballFenxi.vue?vue&type=script&setup=true&lang=ts"
export * from "./FootballFenxi.vue?vue&type=script&setup=true&lang=ts"

import "./FootballFenxi.vue?vue&type=style&index=0&id=279a3215&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279a3215"],['__file',"src/components/player/FootballFenxi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "279a3215"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('279a3215', __exports__)) {
    console.log('reload')
    api.reload('279a3215', __exports__)
  }
  
  module.hot.accept("./FootballFenxi.vue?vue&type=template&id=279a3215&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('279a3215', render)
  })

}


export default __exports__